import React from 'react';

export const UserStatisticsSkeleton: React.FC = () => {
  return (
    <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
      <div className="animate-pulse">
        {/* Header */}
        <div className="h-6 bg-gray-200 rounded w-1/3 mb-6"></div>
        
        {/* Charts - Full Width Layout */}
        <div className="space-y-8">
          {/* Booking Statistics Skeleton */}
          <div className="bg-gradient-to-br from-blue-50 to-indigo-100 rounded-xl p-6">
            <div className="h-6 bg-gray-200 rounded w-1/2 mb-6"></div>
            <div className="h-80 bg-gray-200 rounded"></div>
          </div>
          
          {/* Withdrawal Statistics Skeleton */}
          <div className="bg-gradient-to-br from-purple-50 to-pink-100 rounded-xl p-6">
            <div className="h-6 bg-gray-200 rounded w-1/2 mb-6"></div>
            <div className="h-80 bg-gray-200 rounded"></div>
          </div>
          
          {/* Learning Duration Skeleton */}
          <div className="bg-gradient-to-br from-yellow-50 to-orange-100 rounded-xl p-6">
            <div className="h-6 bg-gray-200 rounded w-1/2 mb-6"></div>
            <div className="h-80 bg-gray-200 rounded"></div>
          </div>
          
          {/* Coaching Duration Skeleton */}
          <div className="bg-gradient-to-br from-teal-50 to-cyan-100 rounded-xl p-6">
            <div className="h-6 bg-gray-200 rounded w-1/2 mb-6"></div>
            <div className="h-80 bg-gray-200 rounded"></div>
          </div>
        </div>
        
        {/* Summary Cards Skeleton */}
        <div className="mt-8 space-y-8">
          {/* Karma Cards Group Skeleton */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="bg-gray-50 border border-gray-200 rounded-2xl p-8 shadow-xl">
                <div className="flex items-center">
                  <div className="h-12 w-12 bg-gray-200 rounded"></div>
                  <div className="ml-5 flex-1">
                    <div className="h-5 bg-gray-200 rounded w-3/4 mb-2"></div>
                    <div className="h-10 bg-gray-200 rounded w-1/2"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          {/* Other Metrics Cards Skeleton */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="bg-gray-50 border border-gray-200 rounded-2xl p-10 shadow-xl">
                <div className="flex items-center">
                  <div className="h-14 w-14 bg-gray-200 rounded"></div>
                  <div className="ml-6 flex-1">
                    <div className="h-5 bg-gray-200 rounded w-3/4 mb-3"></div>
                    <div className="h-12 bg-gray-200 rounded w-1/2"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
